import { cva } from 'class-variance-authority';
const toggleVariantMap = {
    default: 'bg-transparent',
    outline: 'border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground',
};
/** 높이·min-w는 --control-height-* (rules-tokens). default는 md 별칭. */
const toggleSizeMap = {
    default: 'h-[length:var(--control-height)] min-w-[length:var(--control-height)] px-2',
    md: 'h-[length:var(--control-height-md)] min-w-[length:var(--control-height-md)] px-2',
    sm: 'h-[length:var(--control-height-sm)] min-w-[length:var(--control-height-sm)] px-1.5',
    lg: 'h-[length:var(--control-height-lg)] min-w-[length:var(--control-height-lg)] px-2.5',
};
export const toggleCva = {
    variants: {
        variant: toggleVariantMap,
        size: toggleSizeMap,
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
};
export const toggleVariants = cva("inline-flex items-center justify-center space-x-2 rounded-md text-sm font-medium whitespace-nowrap transition-[color,box-shadow] outline-none hover:bg-muted hover:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", toggleCva);
export const toggleVariantKeys = Object.keys(toggleCva.variants.variant);
export const toggleSizeKeys = Object.keys(toggleCva.variants.size);
//# sourceMappingURL=toggle.cva.js.map